module.exports = __webpack_public_path__ + "img/feature_buy_th.00b5b3d2.png";